export default {
  qa: "invalid_api_key",
  Aa: "blacklisted",
  Ba: "no_device_identifier",
  Ra: "invalid_json_response",
  Zh: "empty_response",
  __: "sdk_auth_error",
};
